import React, { Fragment, useEffect, useRef } from "react";
import {
  Box,
  Grid,
  Paper,
  CardMedia,
  Typography,
  Container,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  Table,
  tableCellClasses,
} from "@mui/material";
import styled from "@emotion/styled";
import { useParams } from "react-router-dom";
import Colors from "assets/Style/Colors";
import { CommaSeparator } from "utils";
import {
  FontFamily,
  Images,
  InvoiceGlobal,
  InvoiceLocation,
  InvoiceMail,
  InvoicePhone,
} from "assets";
import { makeStyles } from "@mui/styles";
import { QRCodeCanvas } from "qrcode.react";
import LogoImage from "assets/Images/header_voucher.svg";
import moment from "moment";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

// *For Table Style
const Row = styled(TableRow)(({ theme }) => ({
  border: 0,
}));

const Cell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 14,
    fontFamily: FontFamily.openSans,
    border: 0,
    textAlign: "center",
    whiteSpace: "wrap",
    background: Colors.primary,
    color: Colors.white,
    overFlowWrap: "wrap",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontFamily: FontFamily.openSans,
    textAlign: "center",
    textWrap: "wrap !important",
    padding: "5px !important",

    ".MuiBox-root": {
      display: "flex",
      gap: "6px",
      alignItems: "center",
      justifyContent: "center",
      ".MuiBox-root": {
        cursor: "pointer",
      },
    },
    svg: {
      width: "auto",
      height: "24px",
    },
    ".MuiTypography-root": {
      textTransform: "capitalize",
      fontFamily: FontFamily.openSans,
      textWrap: "nowrap",
    },
    ".MuiButtonBase-root": {
      padding: "8px",
      width: "28px",
      height: "28px",
    },
  },
}));

const useStyle = makeStyles({
  headingBg: {
    margin: "32px 0px",
    padding: "12px 0px",
    textAlign: "center",
  },
  heading: {
    color: Colors.white,
    textTransform: "uppercase",
    fontWeight: 300,
    fontFamily: FontFamily.openSans,
  },
  text: {
    color: Colors.smokeyGrey,
    fontWeight: 300,
    fontFamily: FontFamily.openSans,
  },
  tableCell: {
    backgroundColor: Colors.aliceBlue,
    border: "0.25px solid #D9D9D9",
    "& .MuiTypography-root": {
      padding: "4px 12px",
    },
  },
});

function JournalVoucherDetailInvoice({ voucherDetail, onDone }) {
  const { id } = useParams();
  const contentRef = useRef(null);
  const classes = useStyle();

  const tableHead = [
    "Sr.No",
    "COA Code",
    "COA Name",
    "Debit (AED)",
    "Credit (AED)",
    "Description",
  ];

  useEffect(() => {
    if (!voucherDetail) return;

    setTimeout(async () => {
      const node = contentRef.current;
      if (!node) return;

      await document.fonts.ready;

      const canvas = await html2canvas(node, {
        scale: 2,
        useCORS: true,
        backgroundColor: "#fff",
      });

      const imgData = canvas.toDataURL("image/jpeg", 0.7);

      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "pt",
        format: [999.9, 1061.28],
        compress: true,
      });

      pdf.addImage(imgData, "PNG", 0, 0, 999.9, 1061.28);

      const blob = pdf.output("blob");
      const file = new File(
        [blob],
        `journalVoucher-JV-${voucherDetail?.id}.pdf`,
        { type: "application/pdf" }
      );

      onDone?.(file);
    }, 600);
  }, [voucherDetail]);

  const hasAccountDetail = voucherDetail?.new_voucher;

  return (
    <Container>
      <div ref={contentRef}>
        <Box>
          <Box>
            {
              hasAccountDetail === false ? (
                <>
                <Grid container spacing={0}>
              <Grid item xs={3.5} sm={3.5} md={3.5}>
                <Box
                  component={"img"}
                  src={LogoImage}
                  sx={{ width: "100%", alignItems: "center" }}
                />
              </Grid>
              <Grid item xs={8.5} sm={8.5} md={8.5}>
                <CardMedia image={Images.invoiceHeader} sx={{ mb: 2 }}>
                  <Typography
                    variant="h3"
                    sx={{ py: 3, textAlign: "center", color: Colors.white }}
                  >
                    Galaxy Used Cars Tr. LLC
                  </Typography>
                </CardMedia>
                <Grid
                  container
                  spacing={1.5}
                  alignItems={"center"}
                  justifyContent={"space-evenly"}
                >
                  <Grid item xs={4} sm={4} md={4}>
                    <Box
                      sx={{
                        display: "flex",
                        gap: "5px",
                        alignItems: "center",
                      }}
                    >
                      <InvoicePhone />
                      <Typography
                        variant="body1"
                        sx={{
                          color: Colors.smokeyGrey,
                          fontFamily: FontFamily.openSans,
                        }}
                      >
                        +971 6 510 2000
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={6} sm={6} md={6}>
                    <Box
                      sx={{
                        display: "flex",
                        gap: "5px",
                        alignItems: "center",
                      }}
                    >
                      <InvoiceMail />
                      <Typography
                        variant="body1"
                        sx={{
                          color: Colors.smokeyGrey,
                          fontFamily: FontFamily.openSans,
                        }}
                      >
                        info@galaxyshipping.com
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={4} sm={4} md={4}>
                    <Box
                      sx={{
                        display: "flex",
                        gap: "5px",
                        alignItems: "center",
                      }}
                    >
                      <InvoiceGlobal />
                      <Typography
                        variant="body1"
                        sx={{
                          color: Colors.smokeyGrey,
                          fontFamily: FontFamily.openSans,
                        }}
                      >
                        https://galaxyshipping.com
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={6} sm={6} md={6}>
                    <Box
                      sx={{
                        display: "flex",
                        gap: "5px",
                        alignItems: "center",
                      }}
                    >
                      <InvoiceLocation />
                      <Typography
                        variant="body1"
                        sx={{
                          color: Colors.smokeyGrey,
                          fontFamily: FontFamily.openSans,
                        }}
                      >
                        Ind Area#4 P.O Box 83126, Sharjah , UAE
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Box
              sx={{
                my: 5,
                position: "relative",
                bgcolor: Colors.bluishCyan,
                width: 1,
                height: "12px",
              }}
            >
              <Typography
                component={"span"}
                variant="h2"
                sx={{
                  color: Colors.charcoalGrey,
                  bgcolor: Colors.white,
                  p: 2,
                  letterSpacing: "3px",
                  position: "absolute",
                  right: "90px",
                  top: "-40px",
                }}
              >
                JOURNAL VOUCHER
              </Typography>
            </Box>
            <Box sx={{ display: "flex", columnGap: 1, paddingLeft: 1 }}>
              <Typography>JV # :</Typography>
              <Typography>JV-{voucherDetail?.id}</Typography>
            </Box>
            <Box sx={{ display: "flex", columnGap: 3, paddingLeft: 1 }}>
              <Box sx={{ display: "flex", columnGap: 1 }}>
                <Typography>Processing Date :</Typography>
                <Typography>
                  {moment(voucherDetail?.created_at).format("DD-MM-YYYY")}
                </Typography>
              </Box>
            </Box>
            <Box sx={{ display: "flex", columnGap: 1, paddingLeft: 1 }}>
              <Typography>Customize Date :</Typography>
              <Typography>
                {moment(
                  voucherDetail?.c_date
                    ? voucherDetail?.c_date
                    : voucherDetail?.created_at
                ).format("DD-MM-YYYY")}
              </Typography>
            </Box>
            <Box sx={{ mx: 1 }}>
              <Grid container spacing={0} justifyContent={"space-between"}>
                <Grid item xs={12} sm={11} md={12}>
                  <TableContainer
                    component={Paper}
                    sx={{
                      mt: 2,
                      boxShadow: "0px 8px 18px 0px #9B9B9B1A",
                      borderRadius: 2,
                      maxHeight: "calc(100vh - 330px)",
                    }}
                  >
                    <Table stickyHeader sx={{ minWidth: 500 }}>
                      <TableHead>
                        <TableRow>
                          {tableHead.map((item, index) => (
                            <Cell key={index}>{item}</Cell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {voucherDetail?.entries.map((item, index) => {
                          return (
                            <>
                              <Row
                                key={index}
                                sx={{ bgcolor: index % 2 !== 0 && "#EEFBEE" }}
                              >
                                <Cell>{index + 1}</Cell>
                                {/* <Cell>{item?.jv_id ?? "-"}</Cell> */}
                                <Cell>
                                  {item?.account?.account_code ?? "-"}
                                </Cell>
                                <Cell>{item?.account?.name ?? "-"}</Cell>
                                <Cell>
                                  {CommaSeparator(item?.debit) ?? "-"}
                                </Cell>
                                <Cell>
                                  {CommaSeparator(item?.credit) ?? "-"}
                                </Cell>
                                <Row>
                                  <Typography sx={{ fontSize: 11 }}>
                                    {item?.description ?? "-"}
                                  </Typography>
                                </Row>
                              </Row>
                            </>
                          );
                        })}
                        <Row sx={{ bgcolor: "#EEFBEE" }}>
                          <Cell colSpan={3}>
                            <Typography
                              variant="body1"
                              sx={{ fontWeight: 700 }}
                            >
                              Total
                            </Typography>
                          </Cell>
                          <Cell>
                            <Typography
                              variant="body1"
                              sx={{ fontWeight: 700 }}
                            >
                              {CommaSeparator(
                                parseFloat(voucherDetail?.total_amount).toFixed(
                                  2
                                )
                              )}
                            </Typography>
                          </Cell>
                          <Cell>
                            <Typography
                              variant="body1"
                              sx={{ fontWeight: 700 }}
                            >
                              {CommaSeparator(
                                parseFloat(voucherDetail?.total_amount).toFixed(
                                  2
                                )
                              )}
                            </Typography>
                          </Cell>
                          <Cell></Cell>
                        </Row>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>
                <Grid item xs={6} sm={6} md={6}>
                  <Box
                    className={classes.headingBg}
                    sx={{ bgcolor: Colors.bluishCyan }}
                  >
                    <Typography variant="h4" className={classes.heading}>
                      NOTES
                    </Typography>
                  </Box>
                  <Box sx={{ ml: 4, mr: 2 }}>
                    <Typography variant="body1" className={classes.text}>
                      {voucherDetail?.notes}
                    </Typography>
                  </Box>
                  <Box
                    className={classes.headingBg}
                    sx={{ pl: "32px !important", bgcolor: Colors.aliceBlue }}
                  >
                    <Typography
                      variant="body1"
                      className={classes.heading}
                      sx={{
                        textAlign: "left",
                        color: `${Colors.charcoalGrey} !important`,
                      }}
                    >
                      <b>Created by :</b>

                      <Typography
                        component={"span"}
                        variant="body2"
                        sx={{ textTransform: "none" }}
                      >
                        {voucherDetail?.creator?.name}
                      </Typography>
                    </Typography>
                  </Box>
                  {voucherDetail?.reversed_by && (
                    <Box
                      className={classes.headingBg}
                      sx={{
                        pl: "32px !important",
                        bgcolor: Colors.aliceBlue,
                      }}
                    >
                      <Typography
                        variant="body1"
                        className={classes.heading}
                        sx={{
                          textAlign: "left",
                          color: `${Colors.charcoalGrey} !important`,
                        }}
                      >
                        <b>Reversed by :</b>
                        <Typography
                          component={"span"}
                          variant="body2"
                          sx={{ textTransform: "none" }}
                        >
                          &nbsp; {voucherDetail?.reversed_by}
                        </Typography>
                      </Typography>
                    </Box>
                  )}
                </Grid>
              </Grid>
            </Box>
            <Grid
              container
              spacing={2}
              padding={2}
              justifyContent={"space-between"}
              alignItems={"center"}
            >
              {/* <Grid item xs={9.5} sm={9.5} md={9.5}>
                <Box sx={{ pl: 4, pr: 3, mb: 3, mt: 4 }}>
                  <Typography variant="body1" sx={{ mb: 2 }}>
                    PLEASE READ CAREFULLY BELOW TERM & CONDITION:
                  </Typography>
                  <Typography
                    variant="body2"
                    className={classes.text}
                    sx={{ mb: 1 }}
                  >
                    1 - I've clearly informed and the make the understand all
                    the vehicle information, amount, charges and rates.
                  </Typography>
                  <Typography
                    variant="body2"
                    className={classes.text}
                    sx={{ mb: 1 }}
                  >
                    2 - Kindly pay the due amount within 3 business days from
                    the purchase date to avoid the Late Payment and Storages
                    that will be charged once vehicle arrived to final
                    destination (Further, If there are some special
                    annousment/memo ignore this and follow that)
                  </Typography>
                  <Typography
                    variant="body2"
                    className={classes.text}
                    sx={{ mb: 1 }}
                  >
                    3 - If vehicle got relisted, the relist charges customer has
                    to pay within 3 days otherwise 15% Penalty will applied
                    after 3 days as issued memo on 9/Jun/2022.
                  </Typography>
                  <Typography
                    variant="body2"
                    className={classes.text}
                    sx={{ mb: 1 }}
                  >
                    4 - Galaxy Customer care department will inform you about
                    the latest updates about rates and charges through WhatsApp
                    and emails.
                  </Typography>
                </Box>
              </Grid> */}
              <Grid item xs={10}>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  PLEASE READ CAREFULLY THE T&C:
                </Typography>
                <Box
                  sx={{
                    fontWeight: 500,
                    fontSize: "12px",
                  }}
                >
                  <Typography
                    variant="body2"
                    className={classes.text}
                    sx={{ mb: 1 }}
                  >
                    1- Kindly check or review the invoice/voucher and cash
                    before leaving the counter.
                  </Typography>
                  <Typography
                    variant="body2"
                    className={classes.text}
                    sx={{ mb: 1 }}
                  >
                    2- Our establishment will not be responsible for any delay,
                    mistakes, or omissions in transmission.
                  </Typography>{" "}
                  <Typography
                    variant="body2"
                    className={classes.text}
                    sx={{ mb: 1 }}
                  >
                    3- Our liability is limited to making all necessary
                    amendments in the shortest possible time.
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={2} sm={2} md={2}>
                <Box
                  sx={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <QRCodeCanvas
                    value={
                      window.location.origin +
                      `/journal-voucher-preview/${btoa(id)}`
                    }
                  />
                </Box>
              </Grid>
            </Grid>
            <Box sx={{ pl: 4, pr: 3, py: 1, bgcolor: Colors.primary }}>
              <Typography
                variant="caption"
                sx={{
                  color: Colors.white,
                  fontFamily: FontFamily.openSans,
                }}
              >
                Customer care Contact: Mohammed husni - +971523195682 (Arabic &
                English ) Ardamehr Shoev - +971545836028 (English ,Arabic, Tajik
                & Farsi)
              </Typography>
              <Typography
                variant="caption"
                sx={{
                  color: Colors.white,
                  fontFamily: FontFamily.openSans,
                }}
              >
                Ravin abdul kareem - +971528293801 (Kurdish , Arabic & English)
                Magsat Gylyjov - +97158666403 (Turken , Russian & English)
              </Typography>
            </Box>
                
                </>
              ):(
                <>
                 <Grid container spacing={0}>
                    <Box
                      sx={{
                        width: { xs: "100%", md: "25%" },
                        "@media print": {
                          width: "25%",
                          flex: "0 0 25%",
                        },
                      }}
                    >
                      <Box
                        component="img"
                        src={LogoImage}
                        alt="Ship Logo"
                        sx={{
                          width: "100%",
                          objectFit: "contain",
                          display: "block",
                          maxHeight: "120px",
                        }}
                      />
                    </Box>

                    {/* Right Contact Info */}
                    <Box
                      sx={{
                        // bgcolor: Colors.primary,
                        backgroundColor: "#0C6135 ",
                        padding: 2,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        width: { xs: "100%", md: "75%" },
                        "@media print": {
                          width: "75%",
                          flex: "0 0 75%",
                        },
                      }}
                    >
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                          <Box
                            sx={{
                              display: "flex",
                              gap: 1,
                              alignItems: "center",
                            }}
                          >
                            <InvoicePhone />
                            <Typography
                              variant="body1"
                              sx={{
                                color: Colors.whiteSmoke,
                                fontFamily: FontFamily.openSans,
                                fontSize: 14,
                              }}
                            >
                              +971 6 510 2000
                            </Typography>
                          </Box>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <Box
                            sx={{
                              display: "flex",
                              gap: 1,
                              alignItems: "center",
                            }}
                          >
                            <InvoiceMail />
                            <Typography
                              variant="body1"
                              sx={{
                                color: Colors.whiteSmoke,
                                fontFamily: FontFamily.openSans,
                                fontSize: 14,
                              }}
                            >
                              info@galaxyshipping.com
                            </Typography>
                          </Box>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <Box
                            sx={{
                              display: "flex",
                              gap: 1,
                              alignItems: "center",
                            }}
                          >
                            <InvoiceGlobal />
                            <Typography
                              variant="body1"
                              sx={{
                                color: Colors.whiteSmoke,
                                fontFamily: FontFamily.openSans,
                                fontSize: 14,
                              }}
                            >
                              https://galaxyshipping.com
                            </Typography>
                          </Box>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <Box
                            sx={{
                              display: "flex",
                              gap: 1,
                              alignItems: "center",
                            }}
                          >
                            <InvoiceLocation />
                            <Typography
                              variant="body1"
                              sx={{
                                color: Colors.whiteSmoke,
                                fontFamily: FontFamily.openSans,
                                fontSize: 14,
                              }}
                            >
                              Ind Area#4 P.O Box 83126, Sharjah, UAE
                            </Typography>
                          </Box>
                        </Grid>
                      </Grid>
                    </Box>
                  </Grid>
                  <Box
                    sx={{
                      mt: 5,
                      mb: 0.5,
                      position: "relative",
                      // backgroundColor: '#0C6135 ',
                      bgcolor: Colors.primary,
                      width: 1,
                      height: "12px",
                    }}
                  >
                    <Typography
                      component={"span"}
                      variant="h2"
                      sx={{
                        fontFamily: "Helvetica",
                        color: Colors.charcoalGrey,
                        bgcolor: Colors.white,
                        pl: 2,
                        pr: 2,
                        pt: 2,
                        letterSpacing: "3px",
                        position: "absolute",
                        right: "90px",
                        top: "-40px",
                      }}
                    >
                      JOURNAL VOUCHER
                    </Typography>
                  </Box>

                  <Grid container>
                    <Grid item xs={6} sx={{ px: 2, py: 0.5 }}>
                      <Grid container sx={{ padding: "10px" }}>
                        <Grid item xs={5}>
                          <Typography variant="body1">JV #:</Typography>
                        </Grid>
                        <Grid item xs={7}>
                          <Typography
                            variant="body1"
                            sx={{ fontFamily: FontFamily.NunitoRegular }}
                          >
                            JV-{voucherDetail?.id}
                          </Typography>
                        </Grid>
                        <Grid item xs={5}>
                          <Typography variant="body1">
                            Created By:
                          </Typography>
                        </Grid>
                        <Grid item xs={7}>
                          <Typography
                            variant="body1"
                            sx={{ fontFamily: FontFamily.NunitoRegular }}
                          >
                            {voucherDetail?.creator?.name}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item xs={6} sx={{ px: 2, py: 1, }}>
                      <Grid container sx={{ padding: "10px" }}>
                        <Grid item xs={5}>
                          <Typography variant="body1">
                            Processing Date:
                          </Typography>
                        </Grid>
                        <Grid item xs={7}>
                          <Typography
                            variant="body1"
                            sx={{ fontFamily: FontFamily.NunitoRegular }}
                          >
                            {moment(voucherDetail?.created_at).format("DD-MM-YYYY")}
                          </Typography>
                        </Grid>
                        <Grid item xs={5}>
                          <Typography variant="body1">Customize Date:</Typography>
                        </Grid>
                        <Grid item xs={7}>
                          <Typography
                            variant="body1"
                            sx={{ fontFamily: FontFamily.NunitoRegular }}
                          >
                            {moment(voucherDetail?.c_date ? voucherDetail?.c_date : voucherDetail?.created_at).format("DD-MM-YYYY")}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>


                  <Grid container spacing={2} >
                    <Grid item xs={12} sm={12} sx={{ paddingRight: "30px", paddingLeft: '30px', paddingBottom: '15px' }}>
                      <Grid
                        container
                        sx={{ border: "1px solid #ddd", marginTop: "4px", marginLeft: "15px", fontFamily: "Helvetica" }}
                      >
                        <Grid item xs={12}>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              width: "100%",
                            }}
                          >
                            <Box sx={{ overflowX: "auto", maxWidth: "100%" }}>
                              <table
                                style={{
                                  width: "100%",
                                  borderCollapse: "collapse",
                                  margin: 0,
                                  padding: 0,
                                  tableLayout: "fixed",
                                }}
                              >
                                <thead>
                                  <tr
                                    style={{
                                      background:
                                        "linear-gradient(90deg, #0C6135 0%, #5BBC0F 100%)",
                                      color: Colors.whiteSmoke,
                                      fontWeight: "bold",
                                    }}
                                  >
                                    <th
                                      style={{
                                        padding: "8px",
                                        textAlign: "center",
                                        borderBottom: "2px solid #ddd",
                                        fontSize: "12px",
                                        width: "30px"
                                      }}
                                    >
                                      Sr.#
                                    </th>
                                    <th
                                      style={{
                                        padding: "8px",
                                        textAlign: "center",
                                        borderBottom: "2px solid #ddd",
                                        fontSize: "12px",
                                      }}
                                    >
                                      COA Code
                                    </th>
                                    <th
                                      style={{
                                        padding: "8px",
                                        textAlign: "center",
                                        borderBottom: "2px solid #ddd",
                                        fontSize: "12px",
                                        width: "200px"
                                      }}
                                    >
                                      COA Name
                                    </th>
                                    <th
                                      style={{
                                        padding: "8px",
                                        textAlign: "center",
                                        borderBottom: "2px solid #ddd",
                                        fontSize: "12px",
                                        width: "100px"
                                      }}
                                    >
                                      Debit (AED)
                                    </th>
                                    <th
                                      style={{
                                        padding: "8px",
                                        textAlign: "center",
                                        borderBottom: "2px solid #ddd",
                                        fontSize: "12px",
                                        width: "100px"
                                      }}
                                    >
                                      Credit (AED)
                                    </th>
                                    <th
                                      style={{
                                        padding: "8px",
                                        textAlign: "center",
                                        borderBottom: "2px solid #ddd",
                                        fontSize: "12px",
                                        width: "450px",
                                      }}
                                    >
                                      Description
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {voucherDetail?.entries?.map((item, index) => (

                                    <>
                                      <tr key={item?.id}>
                                        <td
                                          style={{
                                            padding: "8px",
                                            textAlign: "center",
                                            borderBottom: "1px solid #ddd",
                                            borderRight: "1px solid #ddd",
                                            borderLeft: "1px solid #ddd",
                                            fontSize: "12px",
                                            width: "30px"
                                          }}
                                        >
                                          {index + 1}
                                        </td>
                                        <td
                                          style={{
                                            padding: "8px",
                                            textAlign: "left",
                                            borderBottom: "1px solid #ddd",
                                            borderRight: "1px solid #ddd",
                                            fontSize: "12px",
                                          }}
                                        >
                                          {item?.account?.account_code ?? '-'}
                                        </td>
                                        <td
                                          style={{
                                            padding: "8px",
                                            textAlign: "left",
                                            borderBottom: "1px solid #ddd",
                                            borderRight: "1px solid #ddd",
                                            fontSize: "12px",
                                            width: "200px"
                                          }}
                                        >
                                          {item?.account?.name ?? '-'}
                                        </td>
                                        <td
                                          style={{
                                            padding: "8px",
                                            textAlign: "center",
                                            borderBottom: "1px solid #ddd",
                                            borderRight: "1px solid #ddd",
                                            fontSize: "12px",
                                            width: "100px",
                                          }}
                                        >
                                          {item?.debit ?? '-'}
                                        </td>
                                        <td
                                          style={{
                                            padding: "8px",
                                            textAlign: "center",
                                            borderBottom: "1px solid #ddd",
                                            borderRight: "1px solid #ddd",
                                            fontSize: "12px",
                                            width: "100px",
                                          }}
                                        >
                                          {item?.credit ?? '-'}
                                        </td>
                                        <td
                                          style={{
                                            padding: "8px",
                                            textAlign: "center",
                                            borderBottom: "1px solid #ddd",
                                            borderRight: "1px solid #ddd",
                                            fontSize: "12px",
                                            width: "450px",
                                          }}
                                        >
                                          {item?.description}
                                        </td>
                                      </tr>
                                    </>

                                  ))}

                                </tbody>
                              </table>
                            </Box>
                          </Box>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>


                  <Grid container spacing={2} sx={{ ml: 0.2 }}>

                    <Grid item xs={12} sm={6} sx={{ padding: "18px", marginTop: "5px", pl: 0.2, }}>
                      <Grid item xs={12} sx={{ border: "solid", borderWidth: 0.5, borderColor: "lightgray", marginRight: "2px", marginBottom: "10px" }} >
                        <Grid item xs={12}>
                          <Typography variant="h5" sx={{
                            textAlign: "center",
                            background: "linear-gradient(90deg, #0C6135 0%, #5BBC0F 100%)",
                            color: Colors.whiteSmoke,
                            padding: "10px",
                            fontFamily: "Helvetica",
                            fontWeight: "bold",

                          }}>
                            NOTES
                          </Typography>
                        </Grid>
                        <Grid container sx={{ padding: "10px" }}>

                          <Grid item xs={12}>
                            <Typography variant="body1" fontSize='12px'>
                              {voucherDetail?.notes}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid container spacing={1} padding="30px">

                    <Grid item xs={10}>
                      <Typography variant="body1" sx={{ mb: 2 }}>
                        PLEASE READ CAREFULLY THE T&C:
                      </Typography>
                      <Box
                        sx={{
                          fontWeight: 500,
                          fontSize: "12px",
                        }}
                      >
                        <Typography
                          variant="body2"
                          className={classes.text}
                          sx={{ mb: 1 }}
                        >
                          1- Kindly check or review the invoice/voucher and cash
                          before leaving the counter.
                        </Typography>
                        <Typography
                          variant="body2"
                          className={classes.text}
                          sx={{ mb: 1 }}
                        >
                          2- Our establishment will not be responsible for any
                          delay, mistakes, or omissions in transmission.
                        </Typography>{" "}
                        <Typography
                          variant="body2"
                          className={classes.text}
                          sx={{ mb: 1 }}
                        >
                          3- Our liability is limited to making all necessary
                          amendments in the shortest possible time.
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={2} sm={2} md={2}>
                      <Box
                        sx={{
                          height: "100%",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <QRCodeCanvas
                          value={
                            window.location.origin +
                            `/journal-voucher-preview/${btoa(id)}`
                          }
                        />
                      </Box>
                    </Grid>
                  </Grid>

                  <Box sx={{ pl: 4, pr: 3, py: 1, backgroundColor: "#0C6135" }}>
                    <Typography
                      variant="caption"
                      sx={{
                        color: Colors.white,
                        fontFamily: FontFamily.openSans,
                      }}
                    >
                      Customer care Contact: Mohammed husni - +971523195682 (Arabic
                      & English ) Ardamehr Shoev - +971545836028 (English ,Arabic,
                      Tajik & Farsi)
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{
                        color: Colors.white,
                        fontFamily: FontFamily.openSans,
                      }}
                    >
                      Ravin abdul kareem - +971528293801 (Kurdish , Arabic &
                      English) Magsat Gylyjov - +97158666403 (Turken , Russian &
                      English)
                    </Typography>
                  </Box>


                </>
              )
            }
            
          </Box>
        </Box>
      </div>
    </Container>
  );
}

export default JournalVoucherDetailInvoice;
